import { StrictMode } from "react";

import { createRoot } from "@moodys/federated";

import { App } from "./App";
import "./index.scss";

const MainApp = () => {
  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
};

export const main = () =>
  createRoot(document.getElementById("root")!).render(<MainApp />);
